<div class="text-center" [ngClass]="{'pro':api.pro}">
	<app-header></app-header>
	<main id="main" class="p-4 xl:border-white">
		<router-outlet></router-outlet>
		<app-home-export *ngIf="api.currentUrl == '/' && api.export"></app-home-export>
		<ng-container *ngIf="api.currentUrl == '/' && !api.export">
			<div class="surface-card" *ngIf="!api.pro && homeImgs">
				<p-carousel [value]="homeImgs" [showNavigators]="false" styleClass="" [autoplayInterval]="3000" [circular]="true" styleClass="surface-card -ml-4 -mr-4 -mt-5 mb-4">
					<ng-template let-img pTemplate="item">
						<a [routerLink]="['/sorties']" >
							<img (load)="$event.target.style.paddingBottom = '0px'" src="https://blackrockgames.fr/upload/compress.php?size=1270&file=home/{{img}}&ratio" class="homeImg w-full border-round"/>
						</a>
					</ng-template>
				</p-carousel>
			</div>
			<div class="bg-white -mx-4" style="margin-top: -1.5rem;" >
				<div class="flex flex-column">
					<div class="bg-white {{api.pro && api.user && api.user.xx_Espace_Pro == 'gss' ? 'flex-order-4' : 'flex-order-0 pt-4'}}" *ngIf="api.pro">
						<p-divider align="center" styleClass="bg-white">
							<h1 class="text-primary mx-2 uppercase">Offres commerciales</h1>
						</p-divider>
						<div class="text-center grid justify-content-center">
							<ng-container *ngFor="let key of api.objectKeys(api.reductions)">
								<div class="sm:col-6 md:col-3 col-12 p-4" >
									<p-image src="https://blackrockgames.fr/assets/offres/{{key}}.jpg?{{month}}" [preview]="true" imageClass="w-full border-round"></p-image>
									<button label="En profiter" pButton (click)="api.goTo('/games/'+api.returnBtoa({PriceListId:key}))" class="w-full"></button>
								</div>
							</ng-container>

							<ng-container *ngFor="let offer of api.ebpOffers">
								<div class="sm:col-6 md:col-3 col-12 p-4"  [ngClass]="{'hidden':offer.hidden}">
									<p-image src="https://cdn.blackrockgames.fr/items/{{offer.Id}}/couverture.png?width=800" [preview]="true" imageClass="w-full border-round" >
										<ng-template pTemplate="indicator">
											<div class="flex flex-column justify-content-center">
												<div class="p-2">{{offer.name}}</div>
												<i class="pi pi-eye"></i>
											</div>
										</ng-template>
									</p-image>
									
									<button label="En profiter" pButton (click)="api.addEbpOffer(offer)" class="w-full"></button>
								</div>
							</ng-container>
							
						</div>
					</div> 

					<div class="surface-800 flex-order-1" *ngIf="news">
						<p-divider align="center" styleClass="surface-800">
							<h1 class="text-primary mx-2 uppercase surface-800">LES NEWS</h1>
						</p-divider>
						<div class="grid news" >
							<ng-container *ngFor="let item of news">
								<!-- <a [routerLink]="['news/'+item.id_page]" class="p-2 sm:col-6 md:col-3 col-12" [innerHTML]="item.imgs[0]" *ngIf="item.from == 'admin' && item.imgs &&  item.imgs[0]"></a> -->
								<div *ngIf="item.from == 'admin' && item.imgs &&  item.imgs[0]"  class="p-2 sm:col-6 md:col-3 col-12">
									<div class="surface-card h-full flex flex-column justify-content-between wpNews">
										
											<a [routerLink]="['news/'+item.id_page]" [innerHTML]="item.imgs[0]">
												<img [src]="item.img" />
											</a>
											
										
										<a [routerLink]="['news/'+item.id_page]" class="mb-2 text-white text-right block">
											En savoir plus...
										</a>
									</div>
								</div>
								<div *ngIf="item.from == 'wp'"  class="p-2 sm:col-6 md:col-3 col-12">
									<div class="surface-card h-full flex flex-column justify-content-between wpNews">
										
											<a [routerLink]="['pages/'+item.slug]">
												<img [src]="item.img" />
											</a>
											<h2 class="text-center" [innerHTML]="item.title"></h2>
											
										
										<a [routerLink]="['pages/'+item.slug]" class="mb-2 text-white text-right block">
											En savoir plus...
										</a>
									</div>
								</div>
							</ng-container>
						</div>

					</div>

					<div class="surface-card {{api.pro && api.user && api.user.xx_Espace_Pro == 'gss' ? 'flex-order-3' : 'flex-order-2'}}">
						<p-divider align="center" styleClass="surface-card">
							<h1 class="text-primary mx-2 uppercase surface-card">Sélection du moment</h1>
						</p-divider>
						<p-carousel *ngIf="onTop.length > 4" [circular]="true" [value]="onTop" [numVisible]="4" [numScroll]="1" [showNavigators]="true" [showIndicators]="false" [responsiveOptions]="responsiveOptions">
							<ng-template let-game pTemplate="item">
								<div class="text-center">
									<app-bloc-game [game]="game"></app-bloc-game>
								</div>
							</ng-template>
						</p-carousel>
						<div class="text-center grid" *ngIf="onTop.length < 5">
							<div class="sm:col-6 md:col-3 col-12" *ngFor="let game of onTop">
								<app-bloc-game [game]="game"></app-bloc-game>
							</div>
						</div>
					</div>

					<div class="surface-800 pb-3 {{api.pro && api.user && api.user.xx_Espace_Pro == 'gss' ? 'flex-order-0 pt-4' : 'flex-order-3'}}">
						<p-divider align="center" styleClass="surface-800">
							<h1 class="text-primary mx-2 surface-800 uppercase cursor-pointer" [routerLink]="['/sorties']" >Sorties du mois</h1>
						</p-divider>
						<p-carousel *ngIf="sorties.length > 4" [circular]="true" [value]="sorties" [numVisible]="4" [numScroll]="1" [showNavigators]="true" [showIndicators]="false" [responsiveOptions]="responsiveOptions">
							<ng-template let-game pTemplate="item">
								<div class="text-center">
									<app-bloc-game [game]="game"  class="white"></app-bloc-game>
								</div>
							</ng-template>
						</p-carousel>
						<div class="text-center grid" *ngIf="sorties.length < 5">
							<div class="sm:col-6 md:col-3 col-12" *ngFor="let game of sorties">
								<app-bloc-game [game]="game"  class="white"></app-bloc-game>
							</div>
						</div>
					</div>

					<div class="surface-card {{api.pro && api.user && api.user.xx_Espace_Pro == 'gss' ? 'flex-order-1' : 'flex-order-4'}}">
						<p-divider align="center" styleClass="surface-card">
							<h1 class="text-primary mx-2">BEST SELLERS</h1>
						</p-divider>
						<div class="text-center grid">
							<div class="sm:col-6 md:col-3 col-12" *ngFor="let game of bestsellers">
								<app-bloc-game [game]="game"></app-bloc-game>
							</div>
						</div>
					</div>
				</div>

				<div class="">
					<p-divider align="center" styleClass="bg-white">
						<h1 class="text-primary mx-2 uppercase">
							<a [routerLink]="['/editeurs']" class="text-primary">Nos éditeurs</a>
						</h1>
					</p-divider>
					<p-carousel [circular]="true" [autoplayInterval]="2000" [value]="api.editors" [numVisible]="6" [numScroll]="3" [showNavigators]="false" [showIndicators]="true" >
						<ng-template let-e pTemplate="item">
							<div class="text-center">
								<a [routerLink]='["/pages/"+e.id_editor_ebp]'>
									<img pTooltip="{{e.name}}" tooltipPosition="top"  class="cursor-pointer" src="https://blackrockgames.fr/upload/editor/350_{{e.logo}}" style="max-width: 150px; max-height: 150px;">
								</a>
							</div>
						</ng-template>
					</p-carousel>
				</div>
			</div>
		</ng-container>
		<app-games *ngIf="api.currentUrl.indexOf('/pages/FAR') === 0"></app-games>
	</main>
	<app-footer></app-footer>
</div>
<p-scrollTop></p-scrollTop>
